'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.extend({
    name: 'slot-provider',
    provide: function provide() {
        return this.provide;
    },

    props: {
        provide: Object
    },
    render: function render() {
        return this.$slots.default && this.$slots.default.find(function (node) {
            return !node.isComment && node.text !== ' ';
        });
    }
});
//# sourceMappingURL=SlotProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/util/SlotProvider.js
// module id = CNZ6
// module chunks = 0